import React from 'react';
import { SettingsSelectCustom } from '../form/settings.Widget';

export const DEFAULT_BOARD_BORDER_STYLE_OPTIONS = [
  { value: 'solid', label: 'Trait normal' },
  { value: 'thick', label: 'Trait epais' },
  { value: 'dotted', label: 'Pointille' },
  { value: 'dashed', label: 'Dash' },
];

export const BoardToolboxBorderStyle = ({
  value = 'solid',
  onChange,
  placeholder = 'Bordure',
  options = DEFAULT_BOARD_BORDER_STYLE_OPTIONS,
  className = 'min-w-24 flex-none',
  buttonClassName = 'min-h-6 py-01 px-05 text-xs bg-main border border-contrast border-opacity-20',
  menuClassName = 'z-60',
}) => (
  <SettingsSelectCustom
    size='sm'
    className={className}
    buttonClassName={buttonClassName}
    menuClassName={menuClassName}
    options={options}
    value={value}
    onChange={event => onChange?.(event.target.value)}
    placeholder={placeholder}
  />
);
